import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';
import { UserSettingsService } from './../../../user-settings/services/user-settings.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Subject } from '@feature/layout/common/responsive-contact-us/responsive-contact-us.types';
import { EntityLookupItemDto } from '@feature/pma-entity/pma-entity-types';

@Injectable({
    providedIn: 'root'
})
export class ContactUsFormService {
    constructor(private readonly formBuilder: UntypedFormBuilder, private readonly userSettingsService: UserSettingsService) {
    }

    /**
     * 
     * @param subjects 
     * @param entitiesLookupItems 
     * @param email 
     * @returns 
     */
    getForm(subjects: Subject[], entitiesLookupItems: EntityLookupItemDto[], email: string, tenants: EntityLookupItemDto[]): UntypedFormGroup {
        return this.formBuilder.group({
            Entity: new UntypedFormControl(tenants.length == 1 ? tenants[0] : undefined, [Validators.required]),
            Unit: new UntypedFormControl(entitiesLookupItems.length == 1 || tenants.length == 1 ? entitiesLookupItems[0].Key : undefined, [Validators.required]),
            Subject: new UntypedFormControl(subjects?.length > 0 ? subjects[0].Uri : undefined),
            Message: new UntypedFormControl('', [Validators.required]),
            EmailAddress: new UntypedFormControl(email, [Validators.email, Validators.required])
        });
    }
}

